import { Link, Navigate, Outlet, useLocation } from 'react-router-dom'
import type { Role } from '../api/types'
import { Icon } from '../components/Icon'
import { humanize } from '../lib/format'
import { useAuth } from './AuthContext'

/** Login redirects back only to local paths: never to another origin. */
export function safeNext(next: string | null | undefined): string {
  if (!next || !next.startsWith('/') || next.startsWith('//') || next.startsWith('/login')) return '/'
  return next
}

export function RequireAuth() {
  const { status } = useAuth()
  const location = useLocation()
  if (status === 'loading') {
    return (
      <div role="status" className="session-check">
        <span className="spinner" aria-hidden="true" />
        Verificando la sesión…
      </div>
    )
  }
  if (status === 'anonymous') {
    const next = location.pathname + location.search
    return <Navigate to={`/login?next=${encodeURIComponent(next)}`} replace />
  }
  return <Outlet />
}

export function Forbidden({ role }: { role?: Role }) {
  return (
    <section className="state-card" aria-labelledby="forbidden-title">
      <div className="state-card__art" aria-hidden="true"><Icon name="lock" size={28} /></div>
      <h1 id="forbidden-title" className="state-card__title">Sin acceso a esta página</h1>
      <p>
        {role ? (
          <>
            El rol actual es <strong>{humanize(role)}</strong>, que no puede abrir esta área. Solicitar acceso a un administrador si es necesario.
          </>
        ) : (
          'Solicitar acceso a un administrador si es necesario.'
        )}
      </p>
      <Link className="btn btn--primary" to="/">
        Volver al panel
      </Link>
    </section>
  )
}

export function RequireRole({ roles }: { roles: Role[] }) {
  const { user } = useAuth()
  if (!user || !roles.includes(user.role)) return <Forbidden role={user?.role} />
  return <Outlet />
}
